export const APP_NAME = 'Optimus';

export const COMPANY_NAME = 'Lecture Publications Ltd.';
export const COMPANY_ADDRESS = '37, North Brook Hall Road, Banglabazar, Dhaka - 1100';

export const VENDOR_NAME = 'Innospace Infotech Ltd';
export const VENDOR_WEBSITE_URL = 'https://innospace.tech/';

export const EMPTY_VALUE = '—';

export const TAKA_SYMBOL = '৳';

export const WEEK_STARTS_ON = 6;

export const SEARCH_COMING_SOON = 'Search is coming soon';

export const LOADING_PLACEHOLDER = 'Loading...';
